module.exports = __webpack_public_path__ + "media/src/images/favicon/apple-touch-icon-dd34e3f4ef4a4c7a61a7297b6efe7a69.png";